/**
 * Addressbook Route Loaders
 */

import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { addressbookApi } from '../api/addressbook-api'
import { addressbookActions } from '../../store/addressbook.slice'

interface RouterContext {
  store: {
    dispatch: Dispatch<UnknownAction>
    getState: () => unknown
  }
}

export const addressbookLoader = async ({ context }: { context: RouterContext }) => {
  const { store } = context
  try {
    store.dispatch(addressbookActions.setLoading(true))
    const [addresses, stats] = await Promise.all([addressbookApi.getAddresses(), addressbookApi.getAddressStats()])
    store.dispatch(addressbookActions.setAddresses(addresses))
    store.dispatch(addressbookActions.setStats(stats))
    return null
  } catch (error) { store.dispatch(addressbookActions.setError((error as Error).message)); return null }
}
